<template>
  <section class="myhome-con">
    <div class="tit-box type1">
      <h1 class="tit-type1">1:1 문의 상세</h1>
      <div>
        <btn :txt="'목록'"
             :size="'small'"
             :color="'white'"
             @click="btnList_click"/>
      </div>
    </div>
    <table class="tb-row">
      <colgroup>
        <col style="width:15%;"/>
        <col style="width:auto;"/>
        <col style="width:15%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>상태</th>
        <td>{{ dirctInqryPrgrStnm }}</td>
        <th>등록일</th>
        <td class="last">{{ rgstDttm }}</td>
      </tr>
      <tr>
        <th>제목</th>
        <td class="last"
            colspan="3">[ {{ dirctInqryTynm }} ] {{ bbstSj }}</td>
      </tr>
      <tr>
        <th>내용</th>
        <td class="last ql-editor"
            colspan="3">
          <div v-html="bbstCn"></div>
        </td>
      </tr>
      <tr v-if="files.length > 0">
        <th>첨부파일</th>
        <td class="last"
            colspan="3">
          <div class="board-view-bt">
            <div class="entry-con">
              <div class="file-att-list">
                <ul>
                  <li v-for="file in files"
                      :key="file.fileSn">
                    <a href="javascript:;"
                       @click="fileDwld_click(file)">
                      <div class="img-com"
                           :class="$file.getExtsnClassByExtsn(file.extsnNm)">
                        <span>{{ file.extsnNm }}</span></div>
                      {{ file.orgnFlnm }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
    <div v-if="ansrBbstSn">
      <div class="tit-box type1 mgt20">
        <h1 class="tit-type1">답변 [ {{ ansrRgstDttm }} ]</h1>
      </div>
      <table class="tb-row">
      <colgroup>
        <col style="width:15%;"/>
        <col style="width:auto;"/>
      </colgroup>
      <tbody>
      <tr>
        <th>내용</th>
        <td class="last"
            colspan="3"
            v-html="ansrBbstCn"></td>
      </tr>
      <tr v-if="ansrFiles.length > 0">
        <th>첨부파일</th>
        <td class="last"
            colspan="3">
          <div class="board-view-bt">
            <div class="entry-con">
              <div class="file-att-list">
                <ul>
                  <li v-for="file in ansrFiles"
                      :key="file.fileSn">
                    <a href="javascript:;"
                       @click="fileDwld_click(file)">
                      <div class="img-com"
                           :class="$file.getExtsnClassByExtsn(file.extsnNm)">
                        <span>{{ file.extsnNm }}</span></div>
                      {{ file.orgnFlnm }}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </td>
      </tr>
      </tbody>
      </table>
    </div>
  </section>
</template>

<script setup>
import {defineProps, defineEmits, onMounted, ref} from 'vue';

import {getUtils, getStore} from "@/utils/import";
const {$axios, $cmmn, $file} = getUtils();
const {$loading} = getStore();

const props = defineProps({
  bbstSn: {
    type: Number,
    required: true
  }
})

const bbstSj = ref('');
const bbstCn = ref('');
const dirctInqryTynm = ref('');
const dirctInqryPrgrStnm = ref('');
const rgstDttm = ref('');
const files = ref([]);

const ansrBbstSn = ref();
const ansrBbstCn = ref('');
const ansrRgstDttm = ref('');
const ansrFiles = ref([]);

const getDirctInqry = async (bbstSn) => {
  const {data} = await $axios.get('/api/cscr/dirct-inqry', {params: {bbstSn}});

  // 본문
  let cn = data.bbstCn;
  if (data.cnImgFiles.length > 0) {
    const {setCn} = await $cmmn.txt.setCnImgSrc(cn, data.cnImgFiles);
    cn = setCn;
  }

  bbstSj.value = data.bbstSj;
  bbstCn.value = cn;
  dirctInqryTynm.value = data.dirctInqryTynm;
  dirctInqryPrgrStnm.value = data.dirctInqryPrgrStnm;
  rgstDttm.value = data.rgstDttm;
  files.value = data.files;

  // 답변
  let ansrCn = data.ansrBbstCn;
  if (data.ansrCnImgFiles.length > 0) {
    const {setCn} = await $cmmn.txt.setCnImgSrc(ansrCn, data.ansrCnImgFiles);
    ansrCn = setCn;
  }

  ansrBbstSn.value = data.ansrBbstSn;
  ansrBbstCn.value = ansrCn;
  ansrRgstDttm.value = data.ansrRgstDttm;
  ansrFiles.value = data.ansrFiles;
}

const fileDwld_click = async ({ncpObjectNm, orgnFlnm}) => {
  try {
    $loading.on();

    await $file.ncp.tcfl.dwld(ncpObjectNm, orgnFlnm);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
}

const emits = defineEmits(['chng-mode']);
const btnList_click = () => {
  moveList();
}

const moveList = () => {
  emits('chng-mode', {mode: 'list'});
}

onMounted(async () => {
  try {
    $loading.on();

    await getDirctInqry(props.bbstSn);
  } catch (e) {
    await $cmmn.errorMsg(e);
  } finally {
    $loading.off();
  }
})
</script>

<style scoped>

</style>
